export default "__VITE_ASSET__tiMxH_F6__"